export interface IGlobalSettingCost {
  monthlyInterest: number | null
  corporateIncomeTax: number | null
  incrementLevel: number | null
}

const initData = {}

export default { initData }
